module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_7042.3b55e365.png";